import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/merchant/auth',
    method: 'post',
    data: {
      identifier: username,
      password: password
    }
  })
}

export function getInfo() {
  return request({
    url: '/user/me',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js